// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appoinment-container {
    background-color: #fff;
    /* height: calc(764px - 160px); */
    /* width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly; */
    margin-top: 30px;
}
.appoinment-container .col {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}
.nav-tabs {
    border-bottom: 0px solid #dee2e6;
    margin-bottom: 30px;
    text-transform: uppercase;
}
.nav-tabs .nav-link {
    border: 1px solid #333;
    font-size: 28px;
    padding: 5px 45px;
    background: #333;
    color: #818181;
    /* border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top-left-radius: 0px; */

}
#controlled-tab-example-tab-buyers {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;    
    border-top-right-radius: 0;
    border-bottom-right-radius: 0px;
    /* padding-bottom: 8px; */
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border-color: #333;
    /* border-top-right-radius:0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px; */
}
#controlled-tab-example-tab-seller {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px; 
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;       
    /* padding-bottom: 8px; */
}
/* .nav-tabs .nav-link.active:hover{
    margin: 1px;
} */
.input-field-wrapper {
    padding: 15px 30px;
}
#bookAppointment {
    margin-bottom: 30px!important;
    /* margin-top: 0!important; */
}
/* .nav {
    justify-content: center;
    display: inline-flex;
} */
.MuiInput-root {
    width: 100%!important;
}
.MuiInputLabel-root.Mui-focused {
    top: -25px!important;
}
.appoinment-header {
    font-size: 44px;
    font-weight: 500;
    text-align: center;
    color: #333;
    margin-bottom: 30px;
}

/* .appoinment-form {
    padding-left: 187px;
    padding-right: 187px;
} */
.MuiInputLabel-shrink.Mui-focused {
    transform: none!important;
    transform-origin: unset!important;
}
.MuiTextField-root {
    width: 100%!important;
}
.Mui-focused {
    top: 0!important;
}
.MuiInputLabel-animated {
    transition: unset!important;
}
.MuiFormLabel-root.Mui-focused {
    color: #333!important;
}
/* .input-field-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
} */

@media (max-width: 1000px) {
    .appoinment-header {
        margin: 20px 0;
    }
    .input-field-wrapper {
        padding: 15px 0;
    }
    .appoinment-form {
        padding: 0;
       
    }

    .input-field-wrapper {
        flex-direction: column;
    }

    .appoinment-container {
        height: 100%;
    }

    .book-button {
        margin: 20px 0;
    }
}

@media (max-width: 700px) {
    .footer-link-logo-container {
        padding: 0 !important;
    }

    .footer-link-wrapper {
        width: 100% !important;
    }

    /* .footer-copyrights-followus-container {
        padding: 0 10px !important;
    } */

    .footer-follow-us {
        margin-right: 20px !important;
    }
}

@media (max-width: 700px) {
    .footer-follow-us {
        margin-right: 0 !important;
    }
}
@media (max-width: 575.98px) { 
    .appoinment-header {
        font-size: 24px;
       
    }
    .nav-tabs .nav-link {
        font-size: 22px;
    }
    .MuiButton-root {
        letter-spacing: inherit !important;
    }
    .appoinment-container {
        margin-top: 20px;
    }
    .nav-tabs {
        margin-bottom: 10px;
    }
    .nav-tabs .nav-link {
        padding: 5px 20px; 
    }
    .MuiTextField-root {
        width: 100%!important;
    }
    .MuiInput-root {
        width: 100%!important;
    }
    .appoinment-container .col {
        margin-left: 0!important;
    }
    .book-button {
        margin: 0 !important;
    }
    .MuiInputLabel-root {
        font-weight: 500!important;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/bookAppoinment.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iCAAiC;IACjC;;;oCAGgC;IAChC,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd;;kCAE8B;;AAElC;AACA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,0BAA0B;IAC1B,+BAA+B;IAC/B,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB;;;sCAGkC;AACtC;AACA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,2BAA2B;IAC3B,8BAA8B;IAC9B,yBAAyB;AAC7B;AACA;;GAEG;AACH;IACI,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;AACA;;;GAGG;AACH;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;;GAGG;AACH;IACI,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,qBAAqB;AACzB;AACA;;;;;GAKG;;AAEH;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;;IAEd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;OAEG;;IAEH;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI;QACI,eAAe;;IAEnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kCAAkC;IACtC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".appoinment-container {\n    background-color: #fff;\n    /* height: calc(764px - 160px); */\n    /* width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly; */\n    margin-top: 30px;\n}\n.appoinment-container .col {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n.nav-tabs {\n    border-bottom: 0px solid #dee2e6;\n    margin-bottom: 30px;\n    text-transform: uppercase;\n}\n.nav-tabs .nav-link {\n    border: 1px solid #333;\n    font-size: 28px;\n    padding: 5px 45px;\n    background: #333;\n    color: #818181;\n    /* border-top-right-radius: 30px;\n    border-bottom-right-radius: 30px;\n    border-top-left-radius: 0px; */\n\n}\n#controlled-tab-example-tab-buyers {\n    border-top-left-radius: 30px;\n    border-bottom-left-radius: 30px;    \n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0px;\n    /* padding-bottom: 8px; */\n}\n.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {\n    border-color: #333;\n    /* border-top-right-radius:0 !important;\n    border-bottom-right-radius: 0 !important;\n    border-top-left-radius: 30px;\n    border-bottom-left-radius: 30px; */\n}\n#controlled-tab-example-tab-seller {\n    border-top-right-radius: 30px;\n    border-bottom-right-radius: 30px; \n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;       \n    /* padding-bottom: 8px; */\n}\n/* .nav-tabs .nav-link.active:hover{\n    margin: 1px;\n} */\n.input-field-wrapper {\n    padding: 15px 30px;\n}\n#bookAppointment {\n    margin-bottom: 30px!important;\n    /* margin-top: 0!important; */\n}\n/* .nav {\n    justify-content: center;\n    display: inline-flex;\n} */\n.MuiInput-root {\n    width: 100%!important;\n}\n.MuiInputLabel-root.Mui-focused {\n    top: -25px!important;\n}\n.appoinment-header {\n    font-size: 44px;\n    font-weight: 500;\n    text-align: center;\n    color: #333;\n    margin-bottom: 30px;\n}\n\n/* .appoinment-form {\n    padding-left: 187px;\n    padding-right: 187px;\n} */\n.MuiInputLabel-shrink.Mui-focused {\n    transform: none!important;\n    transform-origin: unset!important;\n}\n.MuiTextField-root {\n    width: 100%!important;\n}\n.Mui-focused {\n    top: 0!important;\n}\n.MuiInputLabel-animated {\n    transition: unset!important;\n}\n.MuiFormLabel-root.Mui-focused {\n    color: #333!important;\n}\n/* .input-field-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n} */\n\n@media (max-width: 1000px) {\n    .appoinment-header {\n        margin: 20px 0;\n    }\n    .input-field-wrapper {\n        padding: 15px 0;\n    }\n    .appoinment-form {\n        padding: 0;\n       \n    }\n\n    .input-field-wrapper {\n        flex-direction: column;\n    }\n\n    .appoinment-container {\n        height: 100%;\n    }\n\n    .book-button {\n        margin: 20px 0;\n    }\n}\n\n@media (max-width: 700px) {\n    .footer-link-logo-container {\n        padding: 0 !important;\n    }\n\n    .footer-link-wrapper {\n        width: 100% !important;\n    }\n\n    /* .footer-copyrights-followus-container {\n        padding: 0 10px !important;\n    } */\n\n    .footer-follow-us {\n        margin-right: 20px !important;\n    }\n}\n\n@media (max-width: 700px) {\n    .footer-follow-us {\n        margin-right: 0 !important;\n    }\n}\n@media (max-width: 575.98px) { \n    .appoinment-header {\n        font-size: 24px;\n       \n    }\n    .nav-tabs .nav-link {\n        font-size: 22px;\n    }\n    .MuiButton-root {\n        letter-spacing: inherit !important;\n    }\n    .appoinment-container {\n        margin-top: 20px;\n    }\n    .nav-tabs {\n        margin-bottom: 10px;\n    }\n    .nav-tabs .nav-link {\n        padding: 5px 20px; \n    }\n    .MuiTextField-root {\n        width: 100%!important;\n    }\n    .MuiInput-root {\n        width: 100%!important;\n    }\n    .appoinment-container .col {\n        margin-left: 0!important;\n    }\n    .book-button {\n        margin: 0 !important;\n    }\n    .MuiInputLabel-root {\n        font-weight: 500!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
